export type ImageRequirements = {
  enforceLandscape: boolean;
  minWidth: number;
  minHeight: number;
};

export type ImageRejection = 'orientation' | 'resolution';

export const readImageDimensions = (
  file: File,
): Promise<{ width: number; height: number }> =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const image = new Image();

    image.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: image.width, height: image.height });
    };
    image.onerror = (error) => {
      URL.revokeObjectURL(url);
      reject(error);
    };
    image.src = url;
  });

export const hasImageRequirements = ({
  enforceLandscape,
  minWidth,
  minHeight,
}: ImageRequirements) => enforceLandscape || minWidth > 0 || minHeight > 0;

export const findImageRejection = async (
  file: File,
  { enforceLandscape, minWidth, minHeight }: ImageRequirements,
): Promise<ImageRejection | null> => {
  let dimensions: { width: number; height: number };

  try {
    dimensions = await readImageDimensions(file);
  } catch {
    return 'orientation';
  }

  if (enforceLandscape && dimensions.width <= dimensions.height) {
    return 'orientation';
  }

  if (dimensions.width < minWidth || dimensions.height < minHeight) {
    return 'resolution';
  }

  return null;
};
